<template>
    <div class="tile-content">
        <template v-for="tag in transactionTags">
            <v-popper v-if="tag.items" on="hover">
                <div slot="trigger">
                <span class="text-help"
                      :class="getBadgeType(tag.badgeType)"
                      v-popper-trigger>
                    {{ tag.label | capitalize }}
                </span>
                </div>
                <div class="dropdown" slot="content">
                    <div class="dropdown-content dropdown-content-padded">
                        <h2 class="stack-m">{{ tag.label }}</h2>
                        <ul class="list">
                            <li class="list-item" v-for="{name, value} in tag.items">
                                {{ name }}: {{ value }}
                            </li>
                        </ul>
                    </div>
                </div>
            </v-popper>
            <r-badge :type="getBadgeType(tag.badgeType)">{{ tag.label | capitalize }}</r-badge>
        </template>
    </div>
</template>

<script>
    import vPopper from '@/components/v-popper';
    import BADGES_COLOR_MAP from '@/data/badges-color-map';

    export default {
        name: 'transaction-summary-state-tags',
        components: {
            vPopper,
        },
        props: {
            transaction: {
                type: Object,
            },
        },
        computed: {
            // Tags
            resultTag() {
                if (this.transaction.isScheduled) {
                    return {label: 'Scheduled', badgeType: 'badge-positive'};
                }
                const {result} = this.transaction;
                const badgeType = BADGES_COLOR_MAP.result[result];
                return {label: this.$filters.capitalize(this.$filters.unKebabCase(result)), badgeType};
            },
            rebillTag() {
                const {rebillNumber} = this.transaction;
                return rebillNumber && {label: `Rebill ${rebillNumber}`, badgeType: 'badge-warning'};
            },
            retryTag() {
                const {retryNumber} = this.transaction;
                return retryNumber && {label: `Retry ${retryNumber}`, badgeType: 'badge-warning'};
            },
            typeTag() {
                return {label: this.transaction.type};
            },
            threeDSTag() {
                if (!this.transaction.has3ds) {
                    return false;
                }
                const {threeDSecure: {enrolled, authenticated, liability}} = this.transaction;
                return {
                    label: '3DS',
                    items: [
                        {name: 'Enrolled', value: enrolled || '—'},
                        {name: 'Authenticated', value: authenticated || '—'},
                        {name: 'Liability', value: liability || '—'},
                    ],
                };
            },
            dynamicCCTag() {
                if (!this.transaction.hasDcc) {
                    return false;
                }
                const {
                    dcc: {
                        base, quote, usdMarkup, outcome,
                    },
                } = this.transaction;
                return {
                    label: 'DCC',
                    items: [
                        {name: 'Base', value: this.$filters.monetizeExplicit(base.amount, base.currency)},
                        {name: 'Quote', value: this.$filters.monetizeExplicit(quote.amount, quote.currency)},
                        {name: 'USD Markup', value: usdMarkup},
                        {name: 'Outcome', value: outcome},
                    ],
                };
            },
            disputeTag() {
                if (!this.transaction.isDisputed) {
                    return false;
                }
                return {label: 'Disputed', badgeType: 'badge-warning'};
            },
            refundTag() {
                if (!this.transaction.isRefunded) {
                    return false;
                }
                const {status} = this.transaction;
                const badgeType = BADGES_COLOR_MAP.transactionStatus[status];
                return {label: this.$filters.capitalize(this.$filters.unKebabCase(status)), badgeType};
            },
            voidTag() {
                if (!this.transaction.isVoided) {
                    return false;
                }
                return {label: 'Voided', badgeType: 'badge-warning'};
            },
            transactionTags() {
                return [
                    this.resultTag,
                    this.retryTag,
                    this.rebillTag,
                    this.typeTag,
                    this.threeDSTag,
                    this.dynamicCCTag,
                    this.disputeTag,
                    this.refundTag,
                    this.voidTag,
                ].filter(Boolean);
            },
        },
        methods: {
            getBadgeType(badgeType = '') {
                return `badge inline-xs ${badgeType}`;
            },
        },
    };
</script>
